import { AlertCircle, X, Sparkles } from 'lucide-react';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';
import { useGlobalUsageMonitor } from '@/hooks/useGlobalUsageMonitor';
import { useNavigate } from 'react-router-dom';

export function UsageWarningBanner() {
  const { warnings, hasWarnings, dismissWarning } = useGlobalUsageMonitor();
  const navigate = useNavigate();

  if (!hasWarnings) return null;

  const highestWarning = warnings.sort((a, b) => b.percentage - a.percentage)[0];

  const getColorClass = () => {
    if (highestWarning.severity === 'critical') return 'border-destructive/50 bg-destructive/10';
    return 'border-warning/50 bg-warning/10';
  };

  const getTextColor = () => {
    if (highestWarning.severity === 'critical') return 'text-destructive';
    return 'text-warning';
  };

  const appDisplayName = highestWarning.appName
    .replace(/-/g, ' ')
    .replace(/\b\w/g, l => l.toUpperCase());

  return (
    <Alert className={`mb-4 ${getColorClass()} border-2`}>
      <AlertCircle className={`h-4 w-4 ${getTextColor()}`} />
      <AlertTitle className="flex items-center justify-between">
        <span className={getTextColor()}>
          {highestWarning.severity === 'critical' ? '🔴 Limit Nearly Reached!' : '⚠️ Usage Warning'}
        </span>
        <Button
          variant="ghost"
          size="sm"
          onClick={dismissWarning}
          className="h-6 w-6 p-0"
        >
          <X className="h-4 w-4" />
        </Button>
      </AlertTitle>
      <AlertDescription className="flex items-center justify-between mt-2">
        <div>
          <p className="text-foreground font-medium">
            You've used {highestWarning.current} of {highestWarning.limit} {appDisplayName} this month
            ({Math.round(highestWarning.percentage)}%)
          </p>
          {warnings.length > 1 && (
            <p className="text-sm text-muted-foreground mt-1">
              {warnings.length - 1} other app{warnings.length > 2 ? 's' : ''} also near limits
            </p>
          )}
        </div>
        <Button
          onClick={() => navigate('/settings')}
          className="ml-4"
          size="sm"
        >
          <Sparkles className="h-4 w-4 mr-2" />
          Upgrade Plan
        </Button>
      </AlertDescription>
    </Alert>
  );
}
